import { render } from "./DashboardSettings.vue?vue&type=template&id=a81b4476"
import script from "./DashboardSettings.vue?vue&type=script&lang=js"
export * from "./DashboardSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__